const QuitIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2999 0.449951H8.4749C7.8249 0.449951 7.2749 0.999951 7.2749 1.64995V3.37495C7.2749 3.67495 7.5249 3.92495 7.8249 3.92495C8.1249 3.92495 8.3999 3.67495 8.3999 3.37495V1.62495C8.3999 1.57495 8.4249 1.54995 8.4749 1.54995H11.2999C11.8999 1.54995 12.3749 2.02495 12.3749 2.62495V13.35C12.3749 13.95 11.8999 14.425 11.2999 14.425H8.4749C8.4249 14.425 8.3999 14.4 8.3999 14.35V12.625C8.3999 12.325 8.1499 12.075 7.8249 12.075C7.4999 12.075 7.2749 12.325 7.2749 12.625V14.35C7.2749 15 7.8249 15.55 8.4749 15.55H11.2999C12.5249 15.55 13.4999 14.55 13.4999 13.35V2.64995C13.4999 1.42495 12.4999 0.449951 11.2999 0.449951Z"
        fill="currentColor"
        strokeWidth="0.666667"
      />
      <path
        d="M4.4001 8.55H8.8751C9.1751 8.55 9.4251 8.3 9.4251 8C9.4251 7.7 9.1751 7.45 8.8751 7.45H4.4251L5.9751 5.875C6.2001 5.65 6.2001 5.3 5.9751 5.075C5.7501 4.85 5.4001 4.85 5.1751 5.075L2.6751 7.625C2.4501 7.85 2.4501 8.2 2.6751 8.425L5.1751 10.975C5.2751 11.075 5.4251 11.15 5.5751 11.15C5.7251 11.15 5.8501 11.1 5.9751 11C6.2001 10.775 6.2001 10.425 5.9751 10.2L4.4001 8.55Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default QuitIcon;
